import { SessionStorageItems } from 'shared/constants';

export default function getStaticCandidateToken(): string | null {
    return sessionStorage.getItem(SessionStorageItems.CANDIDATE_STATIC_TOKEN);
}

